import React from 'react'
import ProjectLayout from '../../components/projectLayout'
import data from '../../content/projects/groupProposedResearchConferencePaper'

export default function GroupProposedResearchConferencePaper() {
  return <ProjectLayout data={data} />
}
